export default "__VITE_ASSET___MrJzZyj__"